import { DocumentType } from '@/constatns';
import iassign from "immutable-assign";

const UPDATE_EMPLOEYEE_INFO = "UPDATE_EMPLOEYEE_INFO";
const UPDATE_EMPLOEYEE_PHONE = "UPDATE_EMPLOEYEE_PHONE";
const RESET_EMPLOEYEE_INFO = "RESET_EMPLOEYEE_INFO";

export enum EmployeeStatus {
    Registration = 1,        // на оформлении
    PendingConfirmation = 2, // на подтверждении
    Accepted = 3,            // принят
    Dismissed = 4,           // уволен
    Canceled = 5,            // отменен
    ParentalLeave = 6        // отпуск по уходу за ребенком
}

export enum Attachment {
    IdentityDocument = 1,
    EducationDiploma = 2,
    Photo = 3,
    Iban = 4,
    NoCriminalRecord = 5,
    PsychoDispanser = 6,
    NarcologyDispanser = 7,
    FxTrainingCertificate = 8,
    MilitaryId = 9,
    Rvp = 10,
    Vnzh = 11
}

export enum WorkDays {
    FiveTwo = 1,
    TwoTwo = 2,
    ThreeOne = 3,
}

export enum WorkType {
    FullTime = 1,
    PartTime = 2,
    Remote = 3,
    Freelance = 4
}

export interface EmployeeInfo {
    status: number;
    login: string;
    position: { position: string, code: number };
    bankName: "АО «Kaspi Bank»" | "АО «Народный Банк Казахстана»" | "";
    iban: string;
    bik: "CASPKZKA" | "HSBKKZKX" | "";
    bankBin: "971240001315" | "940140000385" | "";
    workType: WorkType; // 1 - 5/2; 2 - 2/2
    depsId: string[] | number[],
    employeeDepartments: {
        id: number,
        departmentId: number,
        hireDate: string,
        workSchedule: number,
        comment: string
    }[];

    firstName: string;
    middleName: string;
    lastName: string;
    iin: string;
    phone: string;
    citizen: string;
    citizenCode: string;
    birthday: Date | null;
    isResident: boolean;

    doctype: "" | DocumentType;
    series: string;
    docNumber: string;
    issuePlace: string;
    issueDate: Date | null;
    validDate: Date | null;

    employeeId: number;
    docId: number;
    adrId: number;
    factAdrId: number;

    country: string;
    countryCode: string;
    region: string;
    postIndex: string;
    locality: string;
    street: string;
    number: string;
    flat: string;

    factCountry: string;
    factCountryCode: string;
    factRegion: string;
    factPostIndex: string;
    factLocality: string;
    factStreet: string;
    factNumber: string;
    factFlat: string;
}

const initialState: EmployeeInfo = {
    status: 1,
    login: "",

    position: { position: "", code: 0 },
    bankName: "",
    iban: "",
    bik: "",
    bankBin: "",
    workType: 1, // 1 - 5/2; 2 - 2/2
    depsId: [],
    employeeDepartments: [],

    isResident: true,
    firstName: "",
    middleName: "",
    lastName: "",
    iin: "",
    phone: "",
    citizen: "Казахстан",
    citizenCode: "KZ",
    birthday: null,
    doctype: "",
    series: "",
    docNumber: "",
    issuePlace: "",
    issueDate: null,
    validDate: null,

    employeeId: 0,
    docId: 0,
    adrId: 0,
    factAdrId: 0,

    country: "Казахстан",
    countryCode: "KZ",
    region: "",
    postIndex: "",
    locality: "",
    street: "",
    number: "",
    flat: "",

    factCountry: "Казахстан",
    factCountryCode: "KZ",
    factRegion: "",
    factPostIndex: "",
    factLocality: "",
    factStreet: "",
    factNumber: "",
    factFlat: "",
};

export default function employeeInfo(state = initialState, action: EmployeeAction) {
    let _state = state;
    switch (action.type) {
        case UPDATE_EMPLOEYEE_INFO:
            return {
                ...iassign(state, action.payload.getProp, action.payload.setProp, null),
            };

        case UPDATE_EMPLOEYEE_PHONE:
            return {
                ...state,
                phone: action.phone,
            };

        case RESET_EMPLOEYEE_INFO:
            return {
                ...initialState,
            };

        default:
            _state = state;
            break;
    }

    return _state;
}

type EmployeeAction =
    | ReturnType<typeof updateEmployeeInfo>
    | ReturnType<typeof updateEmployeePhone>
    | ReturnType<typeof resetEmployeeInfo>;

const updateEmployeeInfo = (
    getProp: (c: EmployeeInfo) => EmployeeInfo,
    setProp: (p: EmployeeInfo) => EmployeeInfo
) => ({
    type: UPDATE_EMPLOEYEE_INFO as typeof UPDATE_EMPLOEYEE_INFO,
    payload: { getProp, setProp },
});

const updateEmployeePhone = (phone: string) => ({
    type: UPDATE_EMPLOEYEE_PHONE as typeof UPDATE_EMPLOEYEE_PHONE,
    phone,
});

const resetEmployeeInfo = () => ({
    type: RESET_EMPLOEYEE_INFO as typeof RESET_EMPLOEYEE_INFO,
});

export const employeeActions = {
    updateEmployeeInfo,
    updateEmployeePhone,
    resetEmployeeInfo,
};
